module.exports = __webpack_public_path__ + "static/logo-3b5baa94333d4e2fe4a4628a1bd2dd81.svg";